import { useState } from 'react';
import { Card, Group, Radio, Stack, Text } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { dateFormat, dateFormatUI, locale } from '@/index';
import dayjs from 'dayjs';

interface StartCareDateCardProps {
  formContext: any;
  disabled?: boolean;
}

export const StartCareDateCard = (props: StartCareDateCardProps) => {
  const form = props.formContext();
  const [startFrom, setStartFrom] = useState(
    form.values.startDate === null ? 'asap' : 'from'
  );

  return (
    <div>
      <Card shadow="sm" padding="md" radius="md" withBorder>
        <Text fw={700} size="large">
          Kdy si přeji zahájit naši službu
        </Text>
        <Radio.Group
          className="mt-3"
          defaultValue={startFrom}
          onChange={value => {
            setStartFrom(value);
            if (value === 'asap') {
              form.setFieldValue('startDate', null);
            } else {
              form.setFieldValue('startDate', dayjs().format(dateFormat));
            }
          }}
          aria-disabled={props.disabled}
        >
          <Stack>
            <Radio
              value="asap"
              label="Co nejdříve"
              checked={startFrom === 'asap'}
              disabled={props.disabled}
              data-testid="start-care-asap"
            />
            <Group>
              <Radio
                value="from"
                label="Od určitého data"
                className="my-2"
                checked={startFrom === 'from'}
                disabled={props.disabled}
                data-testid="start-care-from"
              />
              {startFrom === 'from' && (
                <DateInput
                  className="w-full max-w-[235px] ml-3"
                  variant="filled"
                  placeholder="Vyberte datum"
                  valueFormat={dateFormatUI}
                  locale={locale}
                  value={
                    form.values.startDate === null
                      ? null
                      : dayjs(form.values.startDate, dateFormat).toDate()
                  }
                  onChange={date => {
                    form.setFieldValue(
                      'startDate',
                      dayjs(date).format(dateFormat)
                    );
                  }}
                  error={form.errors.startDate}
                  disabled={props.disabled}
                  data-testid="start-care-date"
                />
              )}
            </Group>
          </Stack>
        </Radio.Group>
      </Card>
    </div>
  );
};
